import { createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "bg" }
const _hoisted_2 = /*#__PURE__*/_createVNode("p", { class: "title" }, "Escrow UI", -1)
const _hoisted_3 = { class: "mb-1" }
const _hoisted_4 = /*#__PURE__*/_createVNode("label", { for: "2020-12-24-programId-escrow-alice" }, "Throwaway private key (as byte array from sollet.io, without the '[]')", -1)
const _hoisted_5 = { class: "mb-1" }
const _hoisted_6 = /*#__PURE__*/_createVNode("label", { for: "2020-12-24-programId-escrow-alice" }, "Program id", -1)
const _hoisted_7 = { class: "mb-1" }
const _hoisted_8 = /*#__PURE__*/_createVNode("label", { for: "" }, "Bob's X token account pubkey", -1)
const _hoisted_9 = { class: "mb-1" }
const _hoisted_10 = /*#__PURE__*/_createVNode("label", { for: "" }, "Bob's Y token account pubkey", -1)
const _hoisted_11 = { class: "mb-1" }
const _hoisted_12 = /*#__PURE__*/_createVNode("label", { for: "" }, "Escrow account pubkey", -1)
const _hoisted_13 = { class: "mb-1" }
const _hoisted_14 = /*#__PURE__*/_createVNode("label", { for: "" }, "Amount X tokens Bob wants", -1)
const _hoisted_15 = { class: "mb-1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode("div", null, [
      _createVNode("div", _hoisted_3, [
        _hoisted_4,
        _withDirectives(_createVNode("input", {
          class: "display-block",
          type: "text",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.formState.privateKey = $event))
        }, null, 512), [
          [_vModelText, _ctx.formState.privateKey]
        ])
      ]),
      _createVNode("div", _hoisted_5, [
        _hoisted_6,
        _withDirectives(_createVNode("input", {
          class: "display-block",
          type: "text",
          id: "2020-12-24-programId-escrow-alice",
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.formState.programId = $event))
        }, null, 512), [
          [_vModelText, _ctx.formState.programId]
        ])
      ]),
      _createVNode("div", _hoisted_7, [
        _hoisted_8,
        _withDirectives(_createVNode("input", {
          class: "display-block",
          type: "text",
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.formState.takerXAccAddress = $event))
        }, null, 512), [
          [_vModelText, _ctx.formState.takerXAccAddress]
        ])
      ]),
      _createVNode("div", _hoisted_9, [
        _hoisted_10,
        _withDirectives(_createVNode("input", {
          class: "display-block",
          type: "text",
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.formState.takerYAccAddress = $event))
        }, null, 512), [
          [_vModelText, _ctx.formState.takerYAccAddress]
        ])
      ]),
      _createVNode("div", _hoisted_11, [
        _hoisted_12,
        _withDirectives(_createVNode("input", {
          class: "display-block",
          type: "text",
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.formState.escrowAccAddress = $event))
        }, null, 512), [
          [_vModelText, _ctx.formState.escrowAccAddress]
        ])
      ]),
      _createVNode("div", _hoisted_13, [
        _hoisted_14,
        _withDirectives(_createVNode("input", {
          class: "display-block",
          type: "number",
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.formState.XTokenExpectedAmount = $event))
        }, null, 512), [
          [_vModelText, _ctx.formState.XTokenExpectedAmount]
        ])
      ]),
      _createVNode("div", _hoisted_15, [
        _createVNode("input", {
          style: {"margin-right":"5px"},
          class: "cursor-pointer border-none bg-btn normal-font-size",
          type: "submit",
          value: "Reset UI",
          onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.resetUI && _ctx.resetUI(...args)))
        }),
        _createVNode("input", {
          class: "cursor-pointer border-none bg-btn normal-font-size",
          type: "submit",
          value: "Take trade",
          onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.onTakeTrade && _ctx.onTakeTrade(...args)))
        })
      ])
    ])
  ]))
}